// src/pages/controleBar/mesas/ComandaItemActions.js
import React from 'react';

const ComandaItemActions = ({
  item,
  comanda,
  comandaFechada,
  onAdicionar,
  onRemover,
  onGerenciar,
}) => {
  const descricao = item.produto?.descricao || item.xProd;
  const itemOriginalMaisRecente = item.itensOriginais?.[item.itensOriginais.length - 1] || item;
  const pedidoIdParaGerenciar = itemOriginalMaisRecente.pedidoId
    || itemOriginalMaisRecente.pedido?.id
    || item.pedidoId
    || item.pedido?.id;
  const itemPossuiPedido = Boolean(pedidoIdParaGerenciar);

  return (
    <div className="acoes-coluna">
      <button
        className="comanda-item-btn plus"
        disabled={comandaFechada}
        onClick={(e) => {
          e.stopPropagation();
          if (comandaFechada) return;
          onAdicionar(item, comanda);
        }}
        aria-label={`Adicionar ${descricao}`}
      >
        +
      </button>

      {itemPossuiPedido ? (
        <>
          <button
            className="comanda-item-btn diminuir"
            disabled={comandaFechada}
            onClick={(e) => {
              e.stopPropagation();
              if (comandaFechada) return;
              onRemover(itemOriginalMaisRecente);
            }}
            title="Diminuir uma unidade"
            aria-label={`Diminuir ${descricao}`}
          >
            −
          </button>

          <button
            className="comanda-item-btn gerenciar"
            onClick={(e) => {
              e.stopPropagation();
              onGerenciar(pedidoIdParaGerenciar);
            }}
          >
            Gerenciar
          </button>
        </>
      ) : (
        <button
          className="comanda-item-btn excluir"
          disabled={comandaFechada}
          onClick={(e) => {
            e.stopPropagation();
            if (comandaFechada) return;
            onRemover(item);
          }}
        >
          Excluir
        </button>
      )}
    </div>
  );
};

export default ComandaItemActions;
